if (!customElements.get('product-card-color-swatches')) {
  class ProductCardColorSwatches extends HTMLElement {
    constructor() {
      super();

      this.swatchInputs = this.querySelectorAll('input');
      this.swatchLabels = this.querySelectorAll('label');
      this.productCard = this.closest('[data-product-card]');
      this.productCardImage = this.productCard.querySelector('[data-product-card-image]');
      this.productCardHoverImage = this.productCard.querySelector('[data-product-card-hover-image]');
      this.productCardShowAllSwatchButtons = this.productCard.querySelectorAll('[data-product-card-show-all-swatches]');
      this.fieldSet = this.productCard.querySelector('fieldset');

      if (this.swatchInputs.length) {
        this.swatchInputs.forEach((swatchInput) => {
          swatchInput.addEventListener('click', this.updateImage.bind(this));
        });
      }

      if (this.productCardShowAllSwatchButtons.length) {
        this.productCardShowAllSwatchButtons.forEach((button) => {
          button.addEventListener('click', this.showAllSwatches.bind(this));
        });
      }
    }

    updateImage() {
      const eventImage = event.target.getAttribute('data-image');

      this.swatchInputs.forEach((swatchInput) => {
        const swatchImage = swatchInput.getAttribute('data-image');

        if (swatchImage && swatchImage === eventImage) {
          swatchInput.classList.add('active');

          if (this.productCardImage) {
            this.productCardImage.removeAttribute('srcset');
            this.productCardImage.setAttribute('src', swatchImage);
          }

          if (this.productCardHoverImage && swatchInput.getAttribute('data-hover-image')) {
            this.productCardHoverImage.removeAttribute('srcset');
            this.productCardHoverImage.setAttribute('src', swatchInput.getAttribute('data-hover-image'));
          }
        } else {
          swatchInput.classList.remove('active');
        }
      });
    }

    showAllSwatches() {
      this.swatchInputs.forEach((swatchInput) => {
        swatchInput.classList.remove('d-none');
      });

      this.swatchLabels.forEach((swatchLabel) => {
        swatchLabel.classList.remove('d-none');
      });

      this.productCardShowAllSwatchButtons.forEach((button) => {
        button.remove();
      });

      this.setAttribute('tabindex', '0');
      this.focus();
    }
  }

  customElements.define('product-card-color-swatches', ProductCardColorSwatches);
}